document.addEventListener("DOMContentLoaded", (event) => {

  if( document.querySelectorAll('.strategy-reporting-item-right .sr-accordion').length > 0) {
    document.querySelectorAll('.strategy-reporting-item-right .sr-accordion').forEach((item)=>{
      var elem = item;
      var flkty = new Flickity( elem, {
        groupCells: 1,
        wrapAround: true, 
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true
      });    
    })
  }  

  if( document.querySelectorAll('.clients-slider').length > 0) {
    document.querySelectorAll('.clients-slider').forEach((item)=>{
      var elem = item;
      var flkty = new Flickity( elem, {
        groupCells: 1,
        wrapAround: true, 
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        arrowShape: 'M1.00842 10.6488L10.0911 19.7315C10.4491 20.0895 11.0305 20.0895 11.3885 19.7315C11.7465 19.3735 11.7465 18.7922 11.3885 18.4342L3.8691 10.9148L25.0119 10.9215C25.5172 10.9608 25.9585 10.5828 25.9972 10.0775C26.0365 9.57212 25.6585 9.13079 25.1532 9.09212C25.1059 9.08879 25.0585 9.08812 25.0119 9.09212L3.8691 9.08545L11.3885 1.56609C11.7465 1.20809 11.7465 0.626752 11.3885 0.26875C11.0305 -0.0892519 10.4491 -0.0899176 10.0911 0.26875L1.00842 9.35145C0.650418 9.70946 0.650418 10.2908 1.00842 10.6488Z'
      });    
    })
  }

  if( document.querySelectorAll('.mobile-plans-slider').length > 0) {
    document.querySelectorAll('.mobile-plans-slider').forEach((item)=>{
      var elem = item;
      var flkty = new Flickity( elem, {
        groupCells: true, 
        wrapAround: true, 
        cellAlign: 'center',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        initialIndex: 1
      }); 
      
      flkty.on( 'change', function( index ) {
        document.querySelectorAll('.mobile-plans-row .mobile-plans-col').forEach((el)=>{
          var dataIndex = el.dataset.col;
          el.classList.remove('active');
          if (dataIndex ==  index) {
            el.classList.add('active');
          }
        })
      });

      flkty.on( 'select', function( index ) {
      });
    })
  }

  
   
  sameHeight('.video-gallery-item', '.video-gallery-item .video-box'); 
  sameHeight('.sr-accordion .sr-accordion-item', '.sr-accordion .sr-accordion-item .sr-item-content'); 
  
   window.addEventListener("resize", function() {
      sameHeight('.video-gallery-item', '.video-gallery-item .video-box');   
      sameHeight('.sr-accordion .sr-accordion-item', '.sr-accordion .sr-accordion-item .sr-item-content');
    });
});

function sameHeight(listitem, item) {
  let productGrids = document.querySelectorAll(listitem),
      gridPositions = [],
      positionGrids = [];
  if(productGrids.length == 0) return;
  
  productGrids.forEach(function(grid) {
    if(gridPositions.indexOf(grid.offsetTop) == -1) gridPositions.push(grid.offsetTop);
  });
  
  gridPositions.forEach(function (position) {
    let grids = Array.from(productGrids).filter(function (grid) {
      return (grid.offsetTop == position)
    });
    positionGrids.push(grids);
  });

  positionGrids.forEach((grids,index) => {
    let heights = []
    grids.forEach(function (grid) {
      let tmp = [];
      grid.querySelectorAll(item).forEach(function(element) {
        element.style.removeProperty('min-height');
        tmp.push(element.offsetHeight);
      });
      heights.push(tmp);
    });
    if(heights.length > 0){
      let totalSelector = Math.max(...heights.map(ele => {
        return ele.length;
      }));
      grids.forEach(function (grid) {
        for (let index = 0; index < totalSelector; index++) {
          let elementHeights = Math.max(...heights.map(ele => {
            return ele[index];
          }));
          grid.querySelectorAll(item)[index].style.minHeight = `${elementHeights}px`;
        }
      });
    }
  });  
}

document.addEventListener("DOMContentLoaded", function() {
  function scrollToSection(sectionId, offset, time) {
    var section = $(sectionId);
    if (section.length > 0) {
      $('html, body').animate({ scrollTop: section.offset().top - offset }, time);
    }
  }

  var scrollButton = document.querySelector('.se_video_only_text .standard__cta');
  var scrollButtonClaim = document.querySelector('.seo-banner-btn');
  var freeSeoButton = document.querySelector('.free-seo-btn');
  var targetSection = document.querySelector('.section-seo-claim');
  
  if (scrollButton) {
    scrollButton.addEventListener("click", function() {
      // targetSection.scrollIntoView({ behavior: 'smooth' });
      scrollToSection("#shopify-section-template--22448958079254__seo_claim_section_mHeX8V", 50, 200);
    });
  }

  if (freeSeoButton) {
    freeSeoButton.addEventListener("click", function() {
      scrollToSection("#shopify-section-template--22448958079254__seo_claim_section_mHeX8V", 50, 500);
    });
  }

  if (scrollButtonClaim) {
    scrollButtonClaim.addEventListener("click", function() {
      // targetSection.scrollIntoView({ behavior: 'smooth' });
      scrollToSection("#shopify-section-template--22448958079254__seo_claim_section_mHeX8V", 50, 800);
    });
  }
});


// Industry Famous Workshop Accordions Start

document.addEventListener("DOMContentLoaded", function () {
  const titleTabs = document.querySelectorAll(".wic-head");
  const firstAccordionItem = document.querySelector(".wic-item");

  // Open the first item on load
  if (firstAccordionItem) {
    const firstTitleTab = firstAccordionItem.querySelector(".wic-head");
    if (firstTitleTab) {
      firstTitleTab.classList.add("active");
      const nextElement = firstTitleTab.nextElementSibling;
      if (nextElement) {
        nextElement.style.maxHeight = nextElement.scrollHeight + "px"; // Open it
      }
    }
  }

  titleTabs.forEach(function (titleTab) {
    titleTab.addEventListener("click", function (e) {
      e.preventDefault();
      const nextElement = titleTab.nextElementSibling;

      if (titleTab.classList.contains("active")) {
        titleTab.classList.remove("active");
        if (nextElement) {
          nextElement.style.maxHeight = null; // Collapse
        }
      } else {
        titleTab.classList.add("active");
        if (nextElement) {
          nextElement.style.maxHeight = nextElement.scrollHeight + "px"; // Expand
        }

        // Close all other accordion items
        const siblings = Array.from(titleTab.closest(".wic-item").parentElement.children);
        siblings.forEach(function (sibling) {
          if (sibling !== titleTab.closest(".wic-item")) {
            const siblingTitleTab = sibling.querySelector(".wic-head");
            if (siblingTitleTab) {
              siblingTitleTab.classList.remove("active");
            }
            const siblingContent = sibling.querySelector(".wic-content");
            if (siblingContent) {
              siblingContent.style.maxHeight = null; // Collapse
            }
          }
        });
      }
    });
  });
});

// Industry Famous Workshop Accordions End

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });